import { Box } from '@mui/material';
import { WccExportedList } from 'entities/wcc/wcc-exported-list/wcc-exported-list';
import { useFileWccList } from 'features/wcc-export/export-list/lib';
import { WccFileFilter } from 'features/wcc/wcc-file-filter';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePagingParams } from 'shared/hooks/paging-params';

export const WccExportedTab = () => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();

  const getFilesRelatedSearchParams = useMemo(() => {
    const relatedFields = ['uploadedById', 'createdAt', 'ourLegalEntityId'];
    const newParams = new URLSearchParams();
    [...searchParams.entries()].forEach(([key, value]) => {
      if (relatedFields.includes(key)) {
        newParams.append(key, value);
      }
    });
    return newParams;
  }, [searchParams]);

  const collection =  useFileWccList(paging, getFilesRelatedSearchParams);

  return (
    <Box mt={2}>
      <WccFileFilter />
      <WccExportedList
        collection={collection}
        paging={paging}
        onChangePaging={setPaging}
      />
    </Box>
  );
};
